import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { RoomType } from '../types';
import { makeAvatarUrl } from './helpers/avatar';
import { roomStreamIdPrefix } from '../constants';
/**
 * Generates an id for accessing a room's stream from redux.
 */ export function getRoomStreamId(roomId) {
    return `${roomStreamIdPrefix}${roomId}`;
}
export function getMessageCursor(messageId, sentAt) {
    return `${sentAt}|${messageId}`;
}
export function getReactionMapFromMessage(message) {
    return {
        heart: message.msg.a_count,
        club: message.msg.b_count,
        diamond: message.msg.c_count,
        spade: message.msg.d_count
    };
}
function makePapiUser(username, uuid, icon, symbol, banned) {
    return {
        userId: uuid,
        useridUuid: uuid,
        username,
        usericon: makeAvatarUrl(username, icon),
        type: symbol,
        isNewDeviant: false,
        isBanned: banned
    };
}
export function roomFetchToRoomItem(rows) {
    return rows.map((row)=>({
            room: {
                name: row.type === RoomType.MULTI ? row.name : undefined,
                type: row.type,
                room_id: row.room_id,
                updated_at: row.updated_at
            },
            roomMeta: {
                flags: row.flags
            },
            dmUser: RoomType.DM ? makePapiUser(row.dm_username, row.dm_user_id, row.dm_usericon, row.dm_symbol, row.dm_user_banned) : undefined,
            lastMsg: row.msg ? {
                msg: row.msg,
                user: makePapiUser(row.msg_username, row.msg_user_id, row.msg_usericon, row.msg_symbol, row.msg_user_banned)
            } : undefined
        }));
}
export function messagesFetchToMessageItem(rows) {
    return rows.map((row)=>({
            msg: _object_spread({}, row),
            user: makePapiUser(row.msg_username, row.msg_user_id, row.msg_usericon, row.msg_symbol, row.msg_user_banned)
        }));
}

//# sourceMappingURL=helpers.js.map